// extracted by mini-css-extract-plugin
export default {"root":"Ex2NkvN7fN88Q2ktzBcM"};